import { render, staticRenderFns } from "./PollResultEntry.vue?vue&type=template&id=49729ddb&scoped=true"
import script from "./PollResultEntry.vue?vue&type=script&lang=js"
export * from "./PollResultEntry.vue?vue&type=script&lang=js"
import style0 from "./PollResultEntry.vue?vue&type=style&index=0&id=49729ddb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49729ddb",
  null
  
)

export default component.exports